// frontend/src/components/ViewtransactionModal.tsx
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { TxContent } from "./types";

interface ViewTransactionModalProps {
    transaction: TxContent;
    onClose: () => void
}

export default function ViewTaskModal({ transaction, onClose }: ViewTransactionModalProps): JSX.Element {
    return (
        <Dialog open onOpenChange={onClose}>
            <DialogContent>
                <div className="mb-4">
                    <DialogTitle className="text-lg font-bold">Transaction Details</DialogTitle>
                </div>
                <div className="space-y-2">
                    <p><strong>Transaction ID:</strong> {transaction.transactionId}</p>
                    <p><strong>Amount:</strong> ₦{transaction.amount.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                    <p><strong>Card Type:</strong> {transaction.cardtype}</p>
                    <p><strong>Cardholder:</strong> {transaction.cardholder || "N/A"}</p>
                    <p><strong>Currency Code:</strong> {transaction.currencyCode || "N/A"}</p>
                    <p><strong>Terminal ID:</strong> {transaction.terminalId}</p>
                    <p><strong>Transaction Date:</strong> {new Date(transaction.dateCreated as string).toLocaleString()}</p>
                    <p><strong>Response Date:</strong> {transaction.responseDate ? new Date(transaction.responseDate).toLocaleString() : "N/A"}</p>
                    <p><strong>Route:</strong> {transaction.route || "N/A"}</p>
                    <p><strong>Response Code:</strong> {transaction.responseCode || "N/A"}</p>
                    <p><strong>Response Message:</strong> {transaction.responsemessage || "N/A"}</p>
                    <p><strong>Merchant Name:</strong> {transaction.merchantName || "N/A"}</p>
                    <p><strong>Merchant ID:</strong> {transaction.merchantId || "N/A"}</p>
                    <p><strong>Stan:</strong> {transaction.stan}</p>
                    {/* <p><strong>Transaction MTI:</strong> {transaction.transactionMti || "N/A"}</p> */}
                    <p><strong>Bank Code:</strong> {transaction.bankCode || "N/A"}</p>
                    <p><strong>Is Reversed:</strong> {transaction.isReversed ? "Yes" : "No"}</p>
                    <p><strong>Status:</strong> {transaction.status || "N/A"}</p>
                    <p><strong>Payment Type:</strong> {transaction.paymentType || "N/A"}</p>
                    <p><strong>Host:</strong> {transaction.host || "N/A"}</p>
                    <p><strong>Fee:</strong> {transaction.fee !== undefined ? transaction.fee : "N/A"}</p>
                    <p><strong>Pan:</strong> {transaction.pan || "N/A"}</p>
                </div>


            </DialogContent>
        </Dialog>
    );
}

